export const getFormPristine = state => state.getIn(['finalForms', 'pristine']);
